import { useProvideInject } from "../lib/provideInjectGenerator";
import { Dimensions } from '@fresh8/vue-utils/src/dimensionSync';

export const {
  provider: provideAdSize,
  injector: injectAdSize
} = useProvideInject<Dimensions>(Symbol('adsize'), { left: 0, top: 0, height: 0, width: 0 });
